/**
 * OnDiem Pro Availability Widget
 * 
 * This is the main entry point for the embeddable widget.
 * It exports the widget initialization function and can be used
 * as an IIFE for direct script inclusion.
 */

import './capture-url';
import { initWidgets } from './core/widget';

// Auto-initialize on DOM ready (single source of initialization)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWidgets);
} else {
  initWidgets();
}

// Export for manual re-initialization if needed
(window as any).OnDiemProAvailability = {
  init: initWidgets,
};
